import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from './shared.service';
import { SharedUtilService } from './shared-util.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [ SharedService, SharedUtilService ]
})
export class SharedModule {}
